import { useState, createContext, useContext } from "react";


const AlertContext = createContext(null)

export const AlertProvider = ({children})=>{
    const [alert, setAlert] = useState(null)
    const push = (title, subtitle="", time=3000) =>{
        setAlert([title, subtitle])
        setTimeout(() => {
            unpush()
            clearTimeout()
        }, time);
    }
    const unpush = ()=>{
        setAlert()
    }
    return (<AlertContext.Provider value={{alert, push, unpush}}>
        {children}
    </AlertContext.Provider>)
}

export const useAlert=()=>{
    return useContext(AlertContext)
}